export default "__VITE_ASSET__CUD7kA7V__"